import { QueryClientProvider } from '@tanstack/react-query';

import React, { FC } from 'react';
import { NikeReactQueryDevtools, reactQueryClient } from './react-query-client';

export const NikeContext: FC = ({ children }) => {
    return (
        <QueryClientProvider client={reactQueryClient}>
            {children}
            <NikeReactQueryDevtools />
        </QueryClientProvider>
    );
};
